/**
 * Labstep
 *
 * @module grid/BatchCreateResourceItems/components/ColumnHeader/DateHeader
 * @desc Batch Create Resource Items DataGrid Header
 */

import { BatchCreateResourceItemsDateHeaderContextMenu } from 'labstep-web/grid/BatchCreateResourceItems/components/ColumnHeader/DateHeader/ContextMenu';
import { BatchCreateResourceItemsDateHeaderTrigger } from 'labstep-web/grid/BatchCreateResourceItems/components/ColumnHeader/DateHeader/Trigger';
import type { BatchCreateResourceItemsColumnHeaderProps } from 'labstep-web/grid/BatchCreateResourceItems/components/ColumnHeader/DateHeader/types';
import type React from 'react';

export const BatchCreateResourceItemsDateHeader: React.FC<
  BatchCreateResourceItemsColumnHeaderProps
> = ({ column, isDatetime = false, ...rest }) => {
  const trigger = (
    <BatchCreateResourceItemsDateHeaderTrigger
      column={column}
      isDatetime={isDatetime}
      {...rest}
    />
  );

  return (
    <BatchCreateResourceItemsDateHeaderContextMenu
      column={column}
      trigger={trigger}
      isDatetime={isDatetime}
      {...rest}
    />
  );
};
